import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading, text" theme="light" className="titleBlock-align-left explore-usecase-cta" mdxType="TitleBlock" />
    <h2 {...{
      "id": "explore-use-cases"
    }}>{`Explore use cases.`}</h2>
    <p>{`Acrobat Sign APIs are used across a variety of industries to meet a wide range of needs.`}</p>
    <ResourceCard slots="link, image, heading, text, buttons" width="25%" theme='light' isFooter btnVariant='cta' contHeight='180px' className="useCaseCard resourceCardCont sales-cta" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "https://business.adobe.com/customer-success-stories/lash-group-case-study.html"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "478px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.81249999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/0d2feefcc08524d98f479fd86bcc3c3f/5530d/6_Image_Sales.webp 320w", "/document-services/static/0d2feefcc08524d98f479fd86bcc3c3f/3c317/6_Image_Sales.webp 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/0d2feefcc08524d98f479fd86bcc3c3f/8980b/6_Image_Sales.jpg 320w", "/document-services/static/0d2feefcc08524d98f479fd86bcc3c3f/74f5b/6_Image_Sales.jpg 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/0d2feefcc08524d98f479fd86bcc3c3f/74f5b/6_Image_Sales.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "sales-and-procurement-contracts"
    }}>{`Sales and procurement contracts.`}</h3>
    <p>{`Reduce time creating, managing, and tracking sales and procurement contracts. Use Acrobat Sign APIs with Acrobat Services to automate manual processes.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://business.adobe.com/customer-success-stories/lash-group-case-study.html"
        }}>{`Read story`}</a></li>
    </ul>
    <ResourceCard slots="link, image, heading, text, buttons" width="25%" theme='light' isFooter btnVariant='cta' contHeight='180px' className="useCaseCard resourceCardCont rental-cta" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "https://business.adobe.com/customer-success-stories/ryder-case-study.html"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "478px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.81249999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/0254455ccd5f8853ecc2d2cc29630185/5530d/6_Image_Rental.webp 320w", "/document-services/static/0254455ccd5f8853ecc2d2cc29630185/3c317/6_Image_Rental.webp 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/0254455ccd5f8853ecc2d2cc29630185/8980b/6_Image_Rental.jpg 320w", "/document-services/static/0254455ccd5f8853ecc2d2cc29630185/74f5b/6_Image_Rental.jpg 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/0254455ccd5f8853ecc2d2cc29630185/74f5b/6_Image_Rental.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "rental-and-leasing-agreements"
    }}>{`Rental and leasing agreements.`}</h3>
    <p>{`Create intuitive and streamlined leasing agreements for your customers that can be accessed and signed on any device.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://business.adobe.com/customer-success-stories/ryder-case-study.html"
        }}>{`Read story`}</a></li>
    </ul>
    <ResourceCard slots="link, image, heading, text, buttons" width="25%" theme='light' isFooter btnVariant='cta' contHeight='180px' className="useCaseCard new-hire-cta" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "https://business.adobe.com/customer-success-stories/cxc-case-study.html"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "478px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.81249999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/e911713a0677a0ffdcb8bde4d3fcd71a/5530d/6_Image_Onboarding.webp 320w", "/document-services/static/e911713a0677a0ffdcb8bde4d3fcd71a/3c317/6_Image_Onboarding.webp 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/e911713a0677a0ffdcb8bde4d3fcd71a/8980b/6_Image_Onboarding.jpg 320w", "/document-services/static/e911713a0677a0ffdcb8bde4d3fcd71a/74f5b/6_Image_Onboarding.jpg 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/e911713a0677a0ffdcb8bde4d3fcd71a/74f5b/6_Image_Onboarding.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "new-hire-onboarding"
    }}>{`New hire onboarding.`}</h3>
    <p>{`Streamline the hiring process by routing offer letters directly to candidates and hiring managers. You can track status in real time, verify identity, and securely capture e-signatures.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://business.adobe.com/customer-success-stories/cxc-case-study.html"
        }}>{`Read story`}</a></li>
    </ul>
    <ResourceCard slots="link, image, heading, text, buttons" width="25%" theme='light' isFooter btnVariant='cta' contHeight='180px' className="useCaseCard financial-cta" mdxType="ResourceCard" />
    <p><a parentName="p" {...{
        "href": "https://business.adobe.com/customer-success-stories/imm-case-study.html"
      }}></a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "478px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.81249999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/70ae22fa108f48113f18c514470a8c32/5530d/6_Image_Financial.webp 320w", "/document-services/static/70ae22fa108f48113f18c514470a8c32/3c317/6_Image_Financial.webp 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/70ae22fa108f48113f18c514470a8c32/8980b/6_Image_Financial.jpg 320w", "/document-services/static/70ae22fa108f48113f18c514470a8c32/74f5b/6_Image_Financial.jpg 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/70ae22fa108f48113f18c514470a8c32/74f5b/6_Image_Financial.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "financial-and-tax-document-workflows"
    }}>{`Financial and tax document workflows.`}</h3>
    <p>{`Transform your workflows and get more out of existing systems by integrating Acrobat Sign. It's easy to create fluid, secure experiences for senders and signers.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://business.adobe.com/customer-success-stories/imm-case-study.html"
        }}>{`Read story`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      